import {Injectable, Inject} from '@angular/core';

import {Observable, Subject} from "rxjs";
import {User} from "../../model/user";
import {UserRestaurantRole} from "../../model/userRestaurantRole";
import {Code} from "../../model/code";

import { AngularFireDatabase, FirebaseListObservable, FirebaseObjectObservable } from 'angularfire2/database';

@Injectable()
export class UserService {

  private user:User;

  private sdkDb;
  private restUser;
  private userRest;
  private userRef;

  private _currentUser$:  Subject<User> = new Subject<User>();

  // user$ = this._currentUser$.asObservable();

  public  user$: FirebaseListObservable<any>;

  constructor(
    private db:AngularFireDatabase,
  )
  {


    this.sdkDb = db.app.database().ref();

    this.restUser = db.list("/restaurantsPerUser");
    this.userRest = db.list("/usersPerRestaurant");
    this.userRef = db.list("/users");

  }

  getUser(currentUserSysUid: string){

    const user$ = this.db.list('users',{
      query:{
        orderByChild:'sysUid',
        equalTo:currentUserSysUid
      }
      })
      .filter(result => result && result.length > 0)
      .map (result => User.fromJson(result[0]));


    return user$;

  }

  userByEmailExist(userEmail:string){
    let userHere = 0;
    const userCount$ = this.db.list('users',{
      query:{
        orderByChild:'email',
        equalTo:userEmail
      }
    })
      .map ( result => result.length);

    return userCount$;
  }



  getUserByEmail(userEmail:string){
      const user$ = this.db.list('users',{
        query:{
          orderByChild:'email',
          equalTo:userEmail
        }
      })
        .filter(result => result && result.length > 0)
        .map ( result =>  User.fromJson(result[0]) );
    return user$;

  }

  getUserByKey(userKey: any) {

    const user$ = this.db.list('users',{
      query:{
        orderByKey: true,
        equalTo:userKey
      }
    })
      .filter(result => result && result.length > 0)
      .map(result => User.fromJson(result[0]))

    return user$;

  }




  createUser(user:User):Observable<any>{


      user.edit = "<span class=\"glyphicon glyphicon-edit\"></span>";
      user.urlPicture = "http://placehold.it/32x32";
    //  TODO replace when updating with real pictures
    const userToSave = Object.assign({},user)
    const newUserKey = this.userRef.push({}).key;

    let dataToSave = {};
    dataToSave["users/"+ newUserKey] = userToSave;

    return this.firebaseUpdate(dataToSave);


  }






  public findUsersPerRestaurant(restaurantId:string):Observable<User[]>{

      const usersperRestaurant$ = this.db.list('usersPerRestaurant/'+restaurantId)
          .filter(results => results && results.length > 0)
          .map (results => results);


    const restaurantUsres$ = usersperRestaurant$
       .map(uspr => uspr.map(upr => this.db.object('users/' + upr.$key)) )
       .flatMap(fbObj => Observable.combineLatest(fbObj))

    return restaurantUsres$;

  }


  public isUserOnRestaurant(restaurantKey:string,userId:string):Observable<any>{


    const useronREstaurant$ = this.db.list("restaurantsPerUser/" + userId + '/' + restaurantKey)
      .filter(results => results && results.length > 0)
      .map (results => results);

    return useronREstaurant$
  }



  getRestaurantsforUser(uidP:string):Observable<any>{


    const restaurantPerUser$ = this.db.list('restaurantsPerUser/'+uidP)
      .filter(result => result && result.length > 0)
      .map ( result =>  result);

    const restaurant$ = restaurantPerUser$
      .map(restpu => restpu.map(rest => this.db.object('restaurants/' + rest.$key)))
      .flatMap(fbObj => Observable.combineLatest(fbObj))

    return restaurant$
  }




  public isAdmin(userId:string):Observable<any>{

    return Observable.create(observer => {
      let user = this.getUser(userId)
        .subscribe(user =>
          this.getRestaurantsforUser(user.$key)
            .subscribe( restaurants =>{
              let imAdmin;
              restaurants.forEach((innerElement) => {
                imAdmin = (innerElement.role == 'admin' || innerElement.role == 'admin-db') && !imAdmin;
              });
              observer.next(imAdmin);
              observer.complete();
            })
        );
    });



  }



  getUserRole(restaurantId: string, userId: string):Observable<any> {

    return  this.db.list("restaurantsPerUser/" + userId + '/' + restaurantId)




  }

  getRegCodeRecord(code:string):Observable<any>{

    const regRecord$ = this.db.list('codes',{
      query:{
        orderByChild:'code',
        equalTo:code
      }
    })
      .filter(result => result && result.length > 0)
      .map ( result =>  Code.fromJson(result[0]) );

    return regRecord$;

  }

  roleSave(dispRole:string){
    let saveRole;
    switch (dispRole) {
      case "Admin":
        saveRole = "admin";
        break;
      case "Admin - Bill Pay":
        saveRole = "admin-bp";
        break;
      case "Monitor":
        saveRole = "waiter";
        break;
      default:
        saveRole = "waiter";
        break;
    }

    return saveRole
  }


  roleDisplay(role:string){
    let dispRole;
    switch (role) {
      case "admin":
        dispRole = "Admin";
        break;
      case "admin-bp":
        dispRole = "Admin - Bill Pay";
        break;
      case "waiter":
        dispRole = "Monitor";
        break;
      default:
        dispRole = "Monitor";
        break;
    }

    return dispRole;

  }



  private firebaseUpdate(dataToSave: {}) {

    const subject = new Subject();

    this.sdkDb.update(dataToSave)
      .then(
        val =>{
          subject.next(val);
          subject.complete();

        },
        err =>{
          subject.error(err);
          subject.complete();

        }
      );

    return subject.asObservable();

  }


  public markCodeAsUsed(codeRecord:Code):Observable<any>{
    let codeRecorId = codeRecord.$key;
    const codeRecordToSave = Object.assign({},codeRecord);
    delete(codeRecordToSave.$key);
    let dataToSave = {};
    dataToSave["codes/"+codeRecorId] = codeRecordToSave;
    return this.firebaseUpdate(dataToSave);

  }

  saveUser(user: User):Observable<any> {

    let userId = user.$key;
    const userToSave = Object.assign({},user);

    // console.log(userToSave);

    delete(userToSave.$key);
    let dataToSave = {};
    dataToSave["users/"+userId] = userToSave;
    return this.firebaseUpdate(dataToSave);


  }





  saveRestUser(usrrstrl:UserRestaurantRole):Observable<any>{
   let saverole = this.roleSave(usrrstrl.role);

   let dataToSave = {};

    dataToSave["restaurantsPerUser/" + usrrstrl.userKey + '/' + usrrstrl.restaurantKey+'/role'] = saverole;
    dataToSave["usersPerRestaurant/" + usrrstrl.restaurantKey + '/' + usrrstrl.userKey + '/role'] = saverole


    return this.firebaseUpdate(dataToSave);

  }



  restaurantsImAdmin(userId:string):Observable<any>{
      return
  }



  createUserRestaurant(userId:string,email:string,restaurantKey:string,role:string):Observable<any>{

    let dataToSave = {};
    let thisUser = { "userid" : userId, "email" : email };

    dataToSave["restaurantsPerUser/" + userId + '/' + restaurantKey+'/role'] = role;
    dataToSave["usersPerRestaurant/" + restaurantKey + '/' + userId + '/role'] = role;

    return this.firebaseUpdate(dataToSave);

  }


  createDeleteLog(userO:Object) {

    const usertoSave = Object.assign({},userO);
    const deleteTableKey = this.sdkDb.child('dellog').push().key;

   let dataToSave = {};

    dataToSave["dellog/"+deleteTableKey] = usertoSave;


    return this.firebaseUpdate(dataToSave);


  }


  public deleteUser(userP: User, restaurantKey : string) :Observable <any>  {


    let userId = userP.$key;
    const userToSave = Object.assign({},userP);
    delete(userToSave.$key);


    let thisRef = [];

    thisRef.push("restaurantsPerUser/" + userId + '/' + restaurantKey);
    thisRef.push("usersPerRestaurant/" + restaurantKey + '/' + userId);


    return this.firebaseDelete(thisRef);

  }


  private firebaseDelete(dataToDelete){


    const subject = new Subject();


    dataToDelete.forEach((innerElement) => {
      this.sdkDb.child(innerElement).remove()
        .then(
          val =>{
            subject.next(val);
            subject.complete();

          },
          err =>{
            subject.error(err);
            subject.complete();

          }
        );
    });




    return subject.asObservable();
  }




}



// WEBPACK FOOTER //
// ./src/app/shared/services/user/user.service.ts